import { useState, useEffect } from "react";
import "./App.css";
import M from "materialize-css";
import { LessonType } from "../types";

const speedOptions = [0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3, 1.4, 1.5];

function Lesson({ lesson }: { lesson: LessonType }) {
  const [cardLang, setCardLang] = useState(0);

  function capitalize(str: string, idx: number) {
    if (idx === 0) return str.charAt(0).toUpperCase() + str.slice(1);
    return str;
  }

  function phraseToArr(transcript: string[][]) {
    const arr: string[][][] = [];
    for (const [german, english, punctuation] of transcript) {
      arr.push([german.split(" "), english.split(" "), [punctuation]]);
    }
    return arr;
  }

  function changeCardLang() {
    setCardLang((cardLang + 1) % 2);
  }

  function updateSpeed(val: number) {
    const player = document.getElementsByTagName("audio")[0];
    player.playbackRate = val;
  }

  useEffect(() => {
    const tooltips = document.querySelectorAll(".tooltipped");
    M.Tooltip.init(tooltips, {});

    const dropdowns = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(dropdowns, {});

    const floatingActionButtons =
      document.querySelectorAll(".fixed-action-btn");
    M.FloatingActionButton.init(floatingActionButtons, {});

    const modals = document.querySelectorAll(".modal");
    M.Modal.init(modals, {});

    const transcriptArray = ["<speak>", "<prosody rate='65%'>\n"];
    transcriptArray.push("</prosody>", "</speak>");
    const transcriptString = transcriptArray.join("\n");
    console.log(transcriptString);
  }, []);

  useEffect(() => {
    const tooltips = document.querySelectorAll(".tooltipped");
    M.Tooltip.init(tooltips, {});
  }, [cardLang, lesson]);

  return (
    <div>
      <div id="vocab-modal" className="modal modal-fixed-footer">
        <div className="modal-content">
          <h4 className="center-align">Vocab {lesson.num}</h4>
          <table className="centered striped">
            <thead>
              <tr>
                <th>German</th>
                <th>English</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(lesson.vocab).map(([german, english]) => (
                <tr>
                  <td>{german}</td>
                  <td>{english}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal-footer">
          <span className="modal-close waves-effect waves-green btn-flat">
            Close
          </span>
        </div>
      </div>
      <div>
        <div className="row">
          <center>
            <a href={`/lesson${Number(lesson.num) - 1}`} className="black-text">
              <i className="material-icons medium left">chevron_left</i>
            </a>
            <a href={`/lesson${Number(lesson.num) + 1}`} className="black-text">
              <i className="material-icons medium right">chevron_right</i>
            </a>
            <h3>Lesson {lesson.num}</h3>
          </center>
        </div>
        {lesson.intro && (
          <div className="row">
            <div className="col s12 m6 l4 offset-m3 offset-l4">
              <div className="card">
                <div className="card-content">
                  <h6>{lesson.intro}</h6>
                </div>
              </div>
            </div>
          </div>
        )}
        {lesson.audio && (
          <div>
            <div className="row">
              <audio
                loop
                controls
                className="col s12 m6 l4 offset-m3 offset-l4"
                src={`https://docs.google.com/uc?export=download&id=${lesson.audio}`}
              ></audio>
            </div>
            <div className="row">
              <center>
                <a
                  href={`https://drive.google.com/uc?authuser=0&id=${lesson.audio}&export=download`}
                  className="download-btn waves-effect waves-light btn  blue-grey lighten-5
 grey-text text-darken-4"
                >
                  <i className="material-icons right">cloud_download</i>
                  Download
                </a>
                <a
                  className="dropdown-trigger speed-btn waves-effect waves-light btn blue-grey lighten-5
                 grey-text text-darken-4 speed-dropdown"
                  href="#!"
                  data-target="speed-dropdown"
                >
                  <i className="material-icons right">settings</i>
                  Speed
                </a>
                <ul id="speed-dropdown" className="dropdown-content">
                  {speedOptions.map((speed) => (
                    <li onClick={() => updateSpeed(speed)}>
                      <span className="grey-text text-darken-3">
                        {speed.toFixed(1)}x
                      </span>
                    </li>
                  ))}
                </ul>
              </center>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col s12 m6 l4 offset-m3 offset-l4">
            <div className="card">
              <div className="card-content">
                <span className="card-title">Transcript</span>
                <div>
                  {phraseToArr(lesson.transcript).map(
                    ([german, english, punctuation]) => (
                      <div>
                        <h6>
                          {cardLang % 2 === 0 &&
                            german.map((_, idx, arr) => (
                              <span
                                className="tooltipped"
                                data-position="top"
                                data-tooltip={lesson.vocab[german[idx]]}
                              >
                                {`${capitalize(german[idx], idx)}${
                                  idx === arr.length - 1 ? punctuation[0] : " "
                                }`}
                              </span>
                            ))}
                          {cardLang % 2 === 1 &&
                            german.map((_, idx, arr) => (
                              <span
                                className="tooltipped"
                                data-position="top"
                                data-tooltip={english[idx]}
                              >
                                {`${capitalize(
                                  lesson.vocab[english[idx]],
                                  idx
                                )}${
                                  idx === arr.length - 1 ? punctuation[0] : " "
                                }`}
                              </span>
                            ))}
                        </h6>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fixed-action-btn">
          <span className="btn-floating btn-large red" onClick={changeCardLang}>
            <i className="large material-icons">translate</i>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Lesson;
